import {
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
  Box,
  HStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FcApprove, FcDisapprove } from "react-icons/fc";
import { MdOutlineLogout, MdWarningAmber } from "react-icons/md";
import { RiFileEditLine, RiForbid2Line, RiQrScan2Line, RiLockPasswordLine } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import CTable from "../../../components/Table/table";
import {
  openCreateStudent,
  openStudentReportModel,
  openUserQRCodeModel,
  openSuspendReasonModel,
} from "../../../modules/admin-modules/models/Actions";
import {
  approvedStudentsListRequest,
  approveStudentRequest,
  clearSessionRequest,
  deleteStudentRequest,
  rejectStudentRequest,
  restrictStudentRequest,
  studentsRequestsListRequest,
  resendPasswordRequest,
} from "../../../modules/admin-modules/students/Actions";
import { getAllGroupsRequest } from "../../../modules/admin-modules/groups/Actions";
import SuspendReasonModal from "./models/suspend-reason";

const CirclesStudentsTable = ({ setAdd, setSelectedData, searchTerm }) => {
  const approvedStudents = useSelector(
    (state) => state.students.approvedStudents
  );
  const pendeingStudents = useSelector(
    (state) => state.students.pendeingStudents
  );
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.students.isLoading);
  const count = useSelector((state) => state.students.count);
  const isRestrict = useSelector((state) => state.students.isRestrict);
  const isSuspend = useSelector((state) => state.students.isSuspend);

  const [offset, setPage] = useState(0);
  const [tab, setTab] = useState("approve");
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [studentGroupId, setStudentGroupId] = useState("");
  const [selected, setSelected] = useState({
    id: "",
  });
  const [suspendStudent, setSuspendStudent] = useState(null);
  const studentsList = tab === "approve" ? approvedStudents : pendeingStudents;
  const groups = useSelector((state) => state.groups.groups);
  const userData = useSelector((state) => state.user.userData);
  const isSuperAdmin = userData?.role?.[0]?.name === "Super Admin";

  useEffect(() => {
    dispatch(getAllGroupsRequest());
  }, [dispatch]);

  useEffect(() => {
    const timeId = setTimeout(() => {
      tab === "approve"
        ? dispatch(approvedStudentsListRequest(pageNumber + 1, searchTerm, studentGroupId))
        : dispatch(studentsRequestsListRequest(pageNumber + 1, searchTerm));
    }, 200);

    return () => {
      clearTimeout(timeId);
    };
  }, [pageNumber, searchTerm, tab, studentGroupId, dispatch]);

  // Function to format phone number for WhatsApp
  const formatPhoneForWhatsApp = (phone) => {
    if (!phone) return null;

    // Remove all spaces, dashes, brackets, and parentheses
    let cleaned = phone.toString().replace(/[\s\-\(\)\[\]]/g, '');

    // Check if it's an Egyptian number (starts with 012, 011, 010, 015)
    if (cleaned.match(/^(012|011|010|015)/)) {
      // Keep the 0 and add country code 2 before it
      cleaned = '2' + cleaned;
    } else {
      // Remove leading + or 00
      if (cleaned.startsWith('+')) {
        cleaned = cleaned.substring(1);
      } else if (cleaned.startsWith('00')) {
        cleaned = cleaned.substring(2);
      }
    }

    return cleaned;
  };

  const viewData = (data) => {
    // Find the original student data from studentsList to preserve original values (not JSX)
    const originalData = studentsList?.find((student) => student.id === data?.id);
    if (originalData) {
      setSelectedData(originalData);
      setSelected(originalData);
    } else {
      setSelectedData(data);
      setSelected(data);
    }
  };

  const PendingData = studentsList?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      student_name: (
        <Text
          cursor="pointer"
          onClick={() => dispatch(openStudentReportModel())}
        >
          {data?.name}
        </Text>
      ),
      group_name: data?.group?.name,
      phone: (
        <HStack spacing={2} alignItems="center">
          <Text>{data?.phone}</Text>
          {data?.phone && (
            <IconButton
              as="a"
              href={`https://wa.me/${formatPhoneForWhatsApp(data?.phone)}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              size="sm"
              colorScheme="green"
              aria-label="WhatsApp"
              icon={<FaWhatsapp />}
              onClick={(e) => e.stopPropagation()}
            />
          )}
        </HStack>
      ),
      approve: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="40px"
          icon={<FcApprove style={{ fontSize: "40px" }} />}
          onClick={() => dispatch(approveStudentRequest(data?.id))}
          isLoading={selected.id == data?.id ? isSuspend : false}
        />
      ),
      reject: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<FcDisapprove style={{ fontSize: "40px" }} />}
          onClick={() => dispatch(rejectStudentRequest(data?.id))}
          isLoading={selected.id == data?.id ? isRestrict : false}
        />
      ),
    };
  });
  const pendingColumns = [
    {
      Header: "رقم الطالب",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "student_name",
    },
    {
      Header: " رقم  الطالب",
      accessor: "phone",
    },
    {
      Header: " المجموعة",
      accessor: "group_name",
    },
    {
      Header: " Approve",
      accessor: "approve",
    },
    {
      Header: " Reject",
      accessor: "reject",
    },
  ];

  const Data = studentsList?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      student_name: (
        <Text
          cursor="pointer"
          onClick={() => dispatch(openStudentReportModel())}
        >
          {data?.name}
        </Text>
      ),
      group_name: data?.group?.name,
      phone: (
        <HStack spacing={2} alignItems="center">
          <Text>{data?.phone}</Text>
          {data?.phone && (
            <IconButton
              as="a"
              href={`https://wa.me/${formatPhoneForWhatsApp(data?.phone)}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              size="sm"
              colorScheme="green"
              aria-label="WhatsApp"
              icon={<FaWhatsapp />}
              onClick={(e) => e.stopPropagation()}
            />
          )}
        </HStack>
      ),
      parent_phone: (
        <HStack spacing={2} alignItems="center">
          <Text>{data?.parent_phone}</Text>
          {data?.parent_phone && (
            <IconButton
              as="a"
              href={`https://wa.me/${formatPhoneForWhatsApp(data?.parent_phone)}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              size="sm"
              colorScheme="green"
              aria-label="WhatsApp"
              icon={<FaWhatsapp />}
              onClick={(e) => e.stopPropagation()}
            />
          )}
        </HStack>
      ),
      code: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiQrScan2Line />}
          onClick={() => dispatch(openUserQRCodeModel())}
        />
      ),

      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={
            <MdWarningAmber
              color={data?.deleted_at == null ? "red" : "green"}
            />
          }
          onClick={() => {
            if (data?.deleted_at != null) {
              dispatch(deleteStudentRequest(data?.id));
            } else {
              setSuspendStudent(data);
              dispatch(openSuspendReasonModel());
            }
          }}
          isLoading={selected.id == data?.id ? isSuspend : false}
        />
      ),
      restrict: (
        <IconButton
          variant="outline"
          color="gray.600"
          border="0"
          aria-label="Call Sage"
          fontSize="20px"
          isLoading={selected.id == data?.id ? isRestrict : false}
          icon={<RiForbid2Line color={data?.restrict == 0 ? "red" : "green"} />}
          onClick={() => {
            const formData = new FormData();
            formData.append("_method", "PUT");
            data?.restrict == 0
              ? formData.append("restrict", 0)
              : formData.append("restrict", 1);
            dispatch(
              restrictStudentRequest({
                id: data?.id,
                formData: formData,
              })
            );
          }}
        />
      ),
      clearSession: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<MdOutlineLogout />}
          onClick={() => dispatch(clearSessionRequest(data?.id))}
        />
      ),
      resendPassword: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Resend Password"
          fontSize="20px"
          icon={<RiLockPasswordLine />}
          onClick={() => {
            setSelected({ id: data?.id });
            dispatch(resendPasswordRequest(data?.id));
          }}
          isLoading={selected.id === data?.id ? isLoading : false}
        />
      ),
      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiFileEditLine />}
          onClick={() => {
            setAdd(false);
            dispatch(openCreateStudent());
          }}
        />
      ),
      subject_name: data?.subject?.name,
    };
  });
  const columns = [
    {
      Header: "رقم الطالب",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "student_name",
    },
    {
      Header: "Asquera code",
      accessor: "user_name",
    },
    ...(isSuperAdmin
      ? [
        {
          Header: "المادة",
          accessor: "subject_name",
        },
      ]
      : []),
    {
      Header: " المجموعة",
      accessor: "group_name",
    },
    {
      Header: " Qr Code",
      accessor: "code",
    },
    {
      Header: " رقم  الطالب",
      accessor: "phone",
    },
    {
      Header: " رقم  ولي الامر",
      accessor: "parent_phone",
    },
    {
      Header: " ايقاف",
      accessor: "delete",
    },
    {
      Header: " Clear Session",
      accessor: "clearSession",
    },
    {
      Header: "Restrict",
      accessor: "restrict",
    },
    {
      Header: "إعادة إرسال كلمة المرور",
      accessor: "resendPassword",
    },
    {
      Header: "تعديل",
      accessor: "edit",
    },

  ];

  const actions = (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label="Options"
        icon={<RiFileEditLine />}
        size="sm"
        fontSize="20px"
        variant="outline"
        border="none"
      />
      <MenuList>
        <MenuItem
          onClick={() => {
            setAdd(false);
            dispatch(openCreateStudent());
          }}
        >
          تعديل
        </MenuItem>
      </MenuList>
    </Menu>
  );

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  return (
    <>
      <Stack
        flexDirection="row"
        gap="10px"
        alignItems="center"
        justifyContent="center"
        my="10"
      >
        <Button
          onClick={() => setTab("pending")}
          style={{
            background: tab == "pending" ? "green" : "",
            color: tab == "pending" ? "white" : "",
          }}
        >
          Pending
        </Button>
        <Button
          mt="0 !important"
          onClick={() => setTab("approve")}
          style={{
            background: tab == "approve" ? "green" : "",
            color: tab == "approve" ? "white" : "",
          }}
        >
          Approved
        </Button>
        {tab === "approve" && (
          <Box w="300px">
            <Select
              options={groupsOptions}
              isMulti={false}
              isClearable
              onChange={(data) => {
                setStudentGroupId(data?.value || "");
              }}
              styles={colourStyles}
              placeholder="Select Group"
            />
          </Box>
        )}
      </Stack>
      <CTable
        selectedData={viewData}
        Columns={tab === "approve" ? columns : pendingColumns}
        Data={tab === "approve" ? Data : PendingData}
        path={"openModel"}
        Actions={actions}
        Title={``}
        subTitle=""
        btnTitle=""
        placeHolder=""
        noSearchBar={true}
        noFilter={true}
        footerBtnTitle
        filterList
        addButton
        addButtonTitle=""
        setPage={setPage}
        setPerPage={setPerPage}
        currentpage={pageNumber}
        setPageNumber={setPageNumber}
        noSecondSearchBar={true}
        isLoading={isLoading}
        perPage={size}
        totalPage={Math.ceil(count / 50)}
      />

      {/* Suspend Reason Modal */}
      <SuspendReasonModal studentData={suspendStudent} />
    </>
  );
};

export default CirclesStudentsTable;
